import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import Spinner from "reactjs-simple-spinner";
import NavBar from "../../../common/NavBar";
import SideBar from "../../../common/SideBar";
import TextField from "@material-ui/core/TextField";
import {ToastContainer} from "react-toastify";


const SmsGateway = (props) => {

    const [loading, setLoading] = useState(true);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [password, setPassword] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState('')

    const handleUpdate = (e) => {
        setUpdateLoading(true);

    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setErrorMessage('')
        setUpdateLoading(false);

    }, []);



    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div
                id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                <div className="content">
                    <div className="container-fluid">
                        <div className="container">
                            {loading && (
                                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                    <Spinner
                                        size="large"
                                        message="Please wait....."
                                        line-fg-color="#64c3c2"
                                    />
                                </div>
                            )}

                            {!loading && (
                                <div className="main-body">

                                    <nav aria-label="breadcrumb" className="main-breadcrumb">
                                        <ol className="breadcrumb">
                                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a>
                                            </Link>
                                             &nbsp;|&nbsp;
                                            <Link to="/settings"><a href><i
                                                className="fa fa-cog"/>&nbsp;Settings</a></Link>
                                             &nbsp;|&nbsp;
                                            <li className="breadcrumb-item active" aria-current="page">Sms Gateway
                                                Settings
                                            </li>
                                        </ol>
                                    </nav>


                                    <div className="row gutters-sm">
                                        <div className="container col-md-6">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex flex-column align-items-center text-center">
                                                        <h2 className="text-primary h2">SMS Gateway Setup</h2>
                                                        <div className="mt-3">
                                                            <h4>Current SMS Gateway</h4>
                                                            <label className="text-secondary mb-1"> Name: EXAMPLE
                                                                API</label>
                                                            <br/>
                                                            <label className="text-secondary mb-1"> url:
                                                                <span
                                                                    className="p-1 m-1">https://smsgateway.com</span>
                                                            </label>

                                                        </div>
                                                        <hr/>
                                                        <div className="mt-3">
                                                            <TextField
                                                                type="text"
                                                                autoComplete="off"
                                                                aria-autocomplete={false}
                                                                className="mb-3"
                                                                label="Gateway Name"
                                                                fullWidth
                                                                required
                                                                name="gateway_name"
                                                                placeholder={'SMS API'}
                                                                // validations={[required]}
                                                                // onChange={handleChange('first_name')}
                                                            />
                                                            <TextField
                                                                type="text"
                                                                autoComplete="off"
                                                                aria-autocomplete={false}
                                                                className="mb-3"
                                                                label="API Url"
                                                                fullWidth
                                                                required
                                                                name="api_url"
                                                                placeholder={'https://api-mapper.sms.com/send.php'}
                                                                // validations={[required]}
                                                                // onChange={handleChange('first_name')}
                                                            />
                                                            <TextField
                                                                type="text"
                                                                autoComplete="off"
                                                                aria-autocomplete={false}
                                                                className="mb-3"
                                                                label="API HTTP method"
                                                                fullWidth
                                                                required
                                                                name="api_url"
                                                                placeholder={'GET'}
                                                                // validations={[required]}
                                                                // onChange={handleChange('first_name')}
                                                            />
                                                        </div>
                                                        <button
                                                            onClick={handleUpdate}
                                                            className="btn btn-sm btn-outline-primary">
                                                            Update Gateway
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default SmsGateway;
